import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';
import { GetStudentById } from '../helper/apiHelper';
import { useHasRole } from './useHasRole';
import { useCurrentUser } from './useCurrentUser';

export const useStudent = (userId: number | undefined) => {
  const hasRole = useHasRole();
  const loggedInUser = useCurrentUser();
  const isStudent = Boolean(loggedInUser?.roles && hasRole(1));
  return useQuery({
    queryKey: [...QUERY_KEYS.STUDENT_DATA, userId],
    queryFn: () => {
      if (!userId) return null;
      return GetStudentById(String(userId));
    },
    enabled: !!userId && isStudent, // only get student if hasRole student
    meta: {
      refetchOnMouseEnter: false,
    },
  });
};
